import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ContentService } from './services/content.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {
  constructor(private contentService: ContentService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.contentService.getSettingsContent().pipe(
      map(settings => {
        if (settings && settings.maintenanceMode) {
          return this.router.createUrlTree(['/maintenance']);
        }
        return true;
      }),
      catchError(() => of(true)) // If error, allow access
    );
  }
}
